<template>
    <DataSortFilter v-bind="$attrs" :model-value="modelValue" label="Sort by:" :options="options" />
</template>

<script lang="ts">
import DataSortFilter from "@/components/DataSortFilter.vue";

export const defaultClientSortBy = "name_ASC";

export default {
    name: "SortClients",
    components: { DataSortFilter },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: String,
            default: defaultClientSortBy
        }
    },
    data() {
        return {
            options: [
                {
                    field: "Name",
                    ascValue: "name_ASC",
                    ascOptionDirection: "A to Z",
                    descValue: "name_DESC",
                    descOptionDirection: "Z to A"
                }
            ]
        };
    }
};
</script>
